import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ReservationsPanel } from "./handle-controls/ReservationsPanel";
import { BlocksPanel } from "./handle-controls/BlocksPanel";

export function HandleControlsTab() {
  return (
    <Tabs defaultValue="reservations">
      <TabsList>
        <TabsTrigger value="reservations">Reservations</TabsTrigger>
        <TabsTrigger value="blocks">Blocked substrings</TabsTrigger>
      </TabsList>
      <TabsContent value="reservations" className="mt-4"><ReservationsPanel /></TabsContent>
      <TabsContent value="blocks" className="mt-4"><BlocksPanel /></TabsContent>
    </Tabs>
  );
}
